<template>
  <div class="sa-section-header">
    <h2 class="sa-section-header__title">{{ title }}</h2>
    <p v-if="subtitle" class="sa-section-header__subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: 'DashboardSectionHeader',
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
  },
};
</script>

<style scoped>
.sa-section-header {
  margin: 0 0 0.85rem;
}

.sa-section-header__title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--dashboard-text, #191c24);
  line-height: 1.3;
}

.sa-section-header__subtitle {
  margin: 0.25rem 0 0;
  font-size: 0.8125rem;
  color: var(--dashboard-muted, #697386);
}
</style>
